export const ROWS_PER_PAGE_OPTIONS = [5, 10, 25];

export const DEFAULT_PAGE_SIZE = 5;

export const ARIA_TABLE_ID = 'tableTitle';
